import { RouteMatchers, ROUTES } from '@app/infrastructure/routes/routes';
import { usePathname } from 'next/navigation';
import { useCallback, useMemo } from 'react';

export function useHomeNavigation() {
    const pathname = usePathname();

    const isEsalesTransport = useMemo(() => {
        return RouteMatchers.isEsalesTransport(pathname);
    }, [pathname]);

    const isEsalesLife = useMemo(() => {
        return RouteMatchers.isEsalesLife(pathname);
    }, [pathname]);

    const isEsalesTravel = useMemo(() => {
        return RouteMatchers.isEsalesTravel(pathname);
    }, [pathname]);

    const isEsalesPersonalAccidents = useMemo(() => {
        return RouteMatchers.isEsalesPersonalAccidents(pathname);
    }, [pathname]);

    const isEsalesHomeInsurance = useMemo(() => {
        return RouteMatchers.isEsalesHome(pathname);
    }, [pathname]);

    const isEsales = useMemo(() => {
        return RouteMatchers.isEsales(pathname);
    }, [pathname]);

    const getHomeLink = useCallback((currentPath: Nullable<string>): string => {
        if (!currentPath) return ROUTES.HOME;

        switch (true) {
            case RouteMatchers.isEsalesTransport(currentPath):
                return ROUTES.ESALES.TRANSPORT.CALCULATOR_LT;
            case RouteMatchers.isEsalesLife(currentPath):
                return ROUTES.ESALES.LIFE.ROOT;
            case RouteMatchers.isEsalesTravel(currentPath):
                return ROUTES.ESALES.TRAVEL.ROOT;
            case RouteMatchers.isEsalesPersonalAccidents(currentPath):
                return ROUTES.ESALES.PERSONAL_ACCIDENTS.ROOT;
            default:
                return ROUTES.HOME;
        }
    }, []);

    const homeLink = getHomeLink(pathname);

    const handleHomeClick = useCallback(() => {
        if (RouteMatchers.isEsales(pathname)) {
            window.location.reload();
        }
    }, [pathname]);

    const shouldReload = useMemo(() => {
        return RouteMatchers.isEsales(pathname);
    }, [pathname]);

    return {
        homeLink,
        handleHomeClick,
        shouldReload,
        isEsalesTransport,
        isEsalesTravel,
        isEsalesLife,
        isEsalesPersonalAccidents,
        isEsalesHomeInsurance,
        isEsales,
    };
}
